var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.893 18.975 9.516 26.35l1.061 1.06 7.369-7.368 7.373 7.469 1.068-1.053-7.38-7.477 7.48-7.48-1.06-1.061-7.474 7.473-7.372-7.47-1.068 1.054z",
    clipRule: "evenodd"
  })));
};
export { SvgCloseIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzYgMzciIGZpbGw9Im5vbmUiCiAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi44OTI3IDE4Ljk3NDZMOS41MTYzOSAyNi4zNTA5TDEwLjU3NzEgMjcuNDExNkwxNy45NDYgMjAuMDQyN0wyNS4zMTg3IDI3LjUxMThMMjYuMzg2NyAyNi40NTg2TDE5LjAwNjcgMTguOTgyTDI2LjQ4NyAxMS41MDE3TDI1LjQyNjMgMTAuNDQxTDE3Ljk1MzQgMTcuOTEzOUwxMC41ODA4IDEwLjQ0NDhMOS41MTI3IDExLjQ5OEwxNi44OTI3IDE4Ljk3NDZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";